import { FC, MouseEvent, ReactNode } from 'react';

import { Tooltip } from 'antd';
import cs from 'classnames';

import styles from './IconButton.module.scss';

export const enum IconButtonTypes {
  Default = 'default',
  Danger = 'danger'
}

interface IconButtonProps {
  className?: string;
  icon: ReactNode;
  onClick: (e: MouseEvent) => void;
  tooltip?: string;
  type?: IconButtonTypes;
}

const IconButton: FC<IconButtonProps> = ({
  className = '',
  icon,
  onClick,
  tooltip,
  type = IconButtonTypes.Default
}: IconButtonProps) => {
  return (
    <Tooltip title={tooltip}>
      <button
        onClick={onClick}
        className={cs(
          styles.button,
          {
            [styles.default]: type === IconButtonTypes.Default,
            [styles.danger]: type === IconButtonTypes.Danger
          },
          className
        )}
        title={tooltip}
      >
        {icon}
      </button>
    </Tooltip>
  );
};

export default IconButton;
